import { cn } from "~/lib/utils";
import { Icon } from "./icons/icon";

type AvatarSize = "sm" | "md" | "lg";

interface AvatarProps {
  src: string | null | undefined;
  alt?: string;
  size?: AvatarSize;
  className?: string;
}

const sizeConfig: Record<AvatarSize, { container: string; icon: string }> = {
  sm: { container: "size-7", icon: "size-5" },
  md: { container: "size-10", icon: "size-6" },
  lg: { container: "size-16", icon: "size-10" },
};

export function Avatar({ src, alt = "", size = "md", className }: AvatarProps) {
  const { container, icon } = sizeConfig[size];

  return (
    <div
      className={cn(
        "rounded-full bg-muted flex items-center justify-center overflow-hidden shrink-0",
        container,
        className,
      )}
    >
      {src ? (
        <img src={src} alt={alt} className="size-full object-cover" />
      ) : (
        <Icon i="user-profile" className={icon} aria-hidden="true" />
      )}
    </div>
  );
}
